import { render, staticRenderFns } from "./SwineIcon.vue?vue&type=template&id=f5ece01c"
import script from "./SwineIcon.vue?vue&type=script&lang=js"
export * from "./SwineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports